import routerOptions0 from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/node_modules/.pnpm/nuxt@3.17.5_@types+node@22.15.32_eslint@9.29.0_sass-embedded@1.89.2_tsx@4.20.3_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}